import { render, staticRenderFns } from "./AccountRemittanceNotAccount.vue?vue&type=template&id=cacfaea2&scoped=true&"
import script from "./AccountRemittanceNotAccount.vue?vue&type=script&lang=js&"
export * from "./AccountRemittanceNotAccount.vue?vue&type=script&lang=js&"
import style0 from "./AccountRemittanceNotAccount.vue?vue&type=style&index=0&id=cacfaea2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacfaea2",
  null
  
)

export default component.exports